import { otherApiClient } from ".";
export const getUserAddress = async ()=>{
    const { data  } = await otherApiClient.market.get("/users/addresses");
    return data;
};
export const postUserAddress = async (params)=>{
    const { data  } = await otherApiClient.market.post("/users/addresses", params);
    return data;
};
export const putUserAddress = async (params)=>{
    const { id , ...addressData } = params;
    const { data  } = await otherApiClient.market.put("/users/addresses/".concat(id), {
        ...addressData
    });
    return data;
};
export const deleteAddress = async (id)=>{
    const { data  } = await otherApiClient.market.delete("/users/addresses/".concat(id));
    return data;
};
export const putDefaultAddress = async (id)=>{
    const { data  } = await otherApiClient.market.put("/users/addresses/".concat(id, "/default"));
    return data;
};
